import React from 'react';
import UIKitRiskChip, { UIKitRiskVariant, UIKitRiskChipProps } from './RiskChip';

// Definimos los valores que puede aceptar el componente.
type RiskValues =
  | 'Low'
  | 'Moderate'
  | 'Substantial'
  | 'High'
  | '1Low'
  | '2Moderate'
  | '3Substantial'
  | '4High';

interface UIKitRiskChipWrapperProps extends Omit<UIKitRiskChipProps, 'variant'> {
  value: RiskValues | string;
}

const UIKitRiskChipWrapper: React.FC<UIKitRiskChipWrapperProps> = ({ value, ...rest }) => {
  const normalizeVariant = (val: string): UIKitRiskVariant => {
    // Primero quitamos los numeros del inicio en caso de que existan.
    const cleanValue = val.replace(/^\d+/, '');

    // Mapeo de valores alternativos a los valores estándar.
    const valueMapping: Record<string, UIKitRiskVariant> = {
      Medium: 'Moderate',

      // Aca podemos agregar mas mapeos si es necesario.
    };

    // Aplicamos el mapeo si existe, sino usamos el cleanValue.
    const mappedValue = (valueMapping[cleanValue] || cleanValue) as UIKitRiskVariant;

    // Variantes validas segun el UIKitRiskVariant.
    const validVariants: UIKitRiskVariant[] = ['High', 'Substantial', 'Moderate', 'Low'];

    if (validVariants.includes(mappedValue)) {
      return mappedValue;
    }

    // Valor por defecto o fallback en caso de que llegue algo inesperado.
    // console.log(`UIKitRiskChipWrapper: Valor no reconocido: "${val}"`);
    return 'N/A' as UIKitRiskVariant;
  };

  const variant = normalizeVariant(value);

  return <UIKitRiskChip {...rest} variant={variant} />;
};

export default UIKitRiskChipWrapper;
